if (!customElements.get('tolin-scrapive-summary')) {
  customElements.define('tolin-scrapive-summary', class extends HTMLElement {
    connectedCallback() {
      this.anchor = this.closest('product-info')?.querySelector('#divUrunOzellikAlani');
      this.scope = this.anchor?.parentElement;
      if (!this.scope) return;

      this.onClick = () => {
        const target = this.scope.querySelector('scrapive-reviews') || this.anchor;
        const headerHeight = document.querySelector('.section-header')?.getBoundingClientRect().height || 0;
        target.style.scrollMarginTop = `${headerHeight + 16}px`;
        target.scrollIntoView({
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start',
        });
      };
      this.querySelector('button').addEventListener('click', this.onClick);

      // Scrapive lazy-builds its reviews. Its own event requests that build
      // without fetching data or accessing private vendor APIs from the theme.
      this.observer = new MutationObserver(() => this.updateCount());
      this.observer.observe(this.scope, { childList: true, subtree: true, characterData: true });
      this.timer = setInterval(() => {
        document.dispatchEvent(new CustomEvent('scrapive:build-reviews'));
        this.updateCount();
      }, 1000);
      // Limit lazy-build retries; the narrowly scoped observer still handles
      // a widget injected later, and disconnects as soon as its count is ready.
      this.timeout = setTimeout(() => clearInterval(this.timer), 60000);
      this.updateCount();
    }

    updateCount() {
      const heading = this.scope.querySelector('scrapive-reviews .reviews-title');
      const match = heading?.textContent.match(/\(([\d\s.,\u0660-\u0669\u06f0-\u06f9]+)\)\s*$/u);
      if (!match) return;
      const digits = match[1].replace(/[\u0660-\u0669\u06f0-\u06f9]/g, (digit) => String(digit.charCodeAt(0) & 15)).replace(/\D/g, '');
      const count = Number(digits);
      if (!Number.isSafeInteger(count) || !digits) return;
      this.querySelector('[data-scrapive-count]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en').format(count);
      this.hidden = count <= 0;
      this.stopWaiting();
    }

    stopWaiting() {
      this.observer?.disconnect();
      clearInterval(this.timer);
      clearTimeout(this.timeout);
    }

    disconnectedCallback() {
      this.stopWaiting();
      this.querySelector('button')?.removeEventListener('click', this.onClick);
    }
  });
}
